export default __webpack_public_path__ + "assets/icon-green-filter.d8333862.webp";